

























































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Button, Icon,Dialog } from "vant";
import customField from "@/components/customField/index.vue";
import { getBrowser } from "@/utils/browser";
import { goBack } from "@/utils/hybirdMethods";
const browser = getBrowser();
const createAccountModule = namespace("createAccount");

@Component({
  name: "ModeSelect",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [customField.name]: customField
  }
})
export default class ModeSelect extends Vue {
  @createAccountModule.Mutation("SAVE_OPEN_MODE_INFO")
  saveOpenModeInfo: any;

  created() {
    // let gettoken: any = "";
    // gettoken = sessionStorage.getItem("token");
    // if (!gettoken) {
    //   this.$router.push({
    //     path: "/login"
    //   });
    // }

	// (this as any).$localstorage.set('phone',this.$route.query.phone)
	// 


	// if(browser.isGetProApp){
	//   		  (this as any).$apis.Check_phone({phone:this.$route.query.phone}).then(res =>{
	//   		  }).catch(err =>{
	//   		  		Dialog.alert({
	//   		  		    title: '提示',
	//   		  		    message: err
	//   		  		}).then(() => {
	//   		  		   goBack();
	//   		  		})
	//   		  })
	// }
  }

  handleClickModeItem(params) {
    this.saveOpenModeInfo(params);
    this.$router.push({ path: "/idcard-upload", query: params });
  }
}
